import { render, staticRenderFns } from "./AudioRecord.vue?vue&type=template&id=2f167fea&scoped=true&"
import script from "./AudioRecord.vue?vue&type=script&lang=ts&"
export * from "./AudioRecord.vue?vue&type=script&lang=ts&"
import style0 from "./AudioRecord.vue?vue&type=style&index=0&id=2f167fea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f167fea",
  null
  
)

export default component.exports